<script lang="ts">
	import { t } from 'svelte-i18n';
	import type { OperationModel } from '../../../models/api/OperationModel';
	import { Quote } from '@wiseed/wikit';
	import { capitalize } from '@wiseed/wikit';
	export let operation: OperationModel;
</script>

{#if operation.vision}
	<section>
		<h2>{capitalize($t('operation.vision'))}</h2>
		<Quote text={operation.vision} classNames="text-lg" />
	</section>
{/if}
